import { render, staticRenderFns } from "./SpinnerTtt.vue?vue&type=template&id=03128462&scoped=true&"
import script from "./SpinnerTtt.vue?vue&type=script&lang=js&"
export * from "./SpinnerTtt.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerTtt.vue?vue&type=style&index=0&id=03128462&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03128462",
  null
  
)

export default component.exports